import { Link, Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { themes } from "../config/themes";

const navItems = [
  { path: "/", label: "Home" },
  { path: "/league-lab", label: "Dashboard" },
  { path: "/records", label: "Records" },
];

export default function Layout({ theme, onThemeChange, themeTestingEnabled = false }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const trophyDisplayTone = theme.id === "trophy" || theme.id === "trophy2" ? "font-medium" : "font-semibold";

  const isActive = (path) =>
    location.pathname === path
      ? "bg-[var(--nav-active-bg)] text-[var(--nav-active-text)] shadow-lg shadow-black/20 ring-1 ring-[var(--border-strong)] font-semibold"
      : "text-[var(--muted-text)] hover:bg-[var(--nav-hover-bg)] hover:text-[var(--text-main)]";

  return (
    <div className="theme-root min-h-screen flex flex-col bg-[var(--page-bg)] text-[var(--text-main)]" style={theme.styles}>
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute inset-0" style={{ background: "var(--page-gradient)" }} />
        <div className="absolute inset-0 theme-page-surface" />
      </div>

      <header className="sticky left-0 right-0 top-0 z-30 w-full border-b py-3 backdrop-blur-xl sm:py-4" style={{ borderColor: "var(--border-soft)", background: "var(--header-bg)" }}>
        <div className="app-chrome-container flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className={`theme-brand truncate text-2xl leading-tight text-[var(--accent-soft)] sm:text-4xl ${trophyDisplayTone}`}>
              Sunday Ledger
            </p>
            <p className="mt-1 truncate text-[9px] font-semibold uppercase tracking-[0.2em] text-[var(--text-main)] sm:mt-2 sm:text-xs sm:tracking-[0.35em]">
              Elite Fantasy Football
            </p>
          </div>

          <nav className="hidden items-center gap-2 rounded-full border p-1 md:flex" style={{ borderColor: "var(--border-soft)", background: "var(--nav-shell-bg)" }}>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`rounded-full px-4 py-2.5 text-sm transition ${isActive(item.path)}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <button
            className="shrink-0 rounded-full border px-3 py-2 text-sm font-medium md:hidden"
            style={{ borderColor: "var(--border-soft)", background: "var(--nav-shell-bg)", color: "var(--text-main)" }}
            onClick={() => setMenuOpen((open) => !open)}
          >
            Menu
          </button>
        </div>

        {themeTestingEnabled ? (
          <div className="app-chrome-container mt-3 flex justify-end">
            <div className="w-full sm:w-auto">
              <label className="sr-only" htmlFor="theme-selector">Theme</label>
              <select
                id="theme-selector"
                value={theme.id}
                onChange={(event) => onThemeChange(event.target.value)}
                className="w-full rounded-2xl border px-4 py-2.5 text-sm font-medium outline-none sm:min-w-[240px]"
                style={{ borderColor: "var(--border-soft)", background: "var(--panel-soft-bg)", color: "var(--text-main)" }}
              >
                {themes.map((option) => (
                  <option key={option.id} value={option.id} style={{ color: "#111111", background: "#ffffff" }}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ) : null}

        {menuOpen && (
          <div className="app-chrome-container mt-3 md:hidden">
            <div className="w-full overflow-hidden rounded-2xl border shadow-2xl shadow-black/30 sm:rounded-3xl" style={{ borderColor: "var(--border-soft)", background: "var(--mobile-nav-bg)" }}>
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block px-5 py-4 text-sm font-medium transition ${isActive(item.path)}`}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </header>

      <main className="relative flex-1 app-shell-padding">
        <div className="app-container">
          <Outlet />
        </div>
      </main>

      <footer className="relative border-t py-5 text-center text-[11px] text-[var(--muted-text)] sm:text-xs" style={{ borderColor: "var(--border-soft)" }}>
        &copy; {new Date().getFullYear()} Sunday Ledger. All rights reserved.
      </footer>
    </div>
  );
}
